type Money = {
    /**
     * Amount as integer value, ex: $1 => 100
     */
    amount: number;
    /**
     * ISO Currency code
     */
    currency: string;
    /**
     * Formatted value as string
     */
    formatted: string;
};

export default Money;

export function isMoney(value: any): value is Money {
    return typeof value === 'object' && value !== null && 'amount' in value && 'currency' in value;
}
